import React, { Component } from 'react';
import SketchPicker from 'react-color/lib/Sketch';
import debounce from 'lodash/debounce';
import { Field } from 'redux-form';

export default class ColorPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayColorPicker: false,
    };

    this.fieldInput = this.setupInput();
  }

  setupInput() {
    return (field) => {
      let picker;
      const { handleClose, handleChange, handleClick } = this;
      const value = field.input.value;

      this.changeColor = debounce((value) => {
        field.input.onChange(value);
      }, 300);

      if (this.state.displayColorPicker) {
        picker = (
          <div className="c-colorpicker__popover">
            <div className="c-colorpicker__popover__cover" onClick={handleClose.bind(this)} />
            <SketchPicker color={{ hex: value }} onChange={handleChange.bind(this)} presetColors={[]} />
          </div>
        );
      }

      return (
        <div className="c-colorpicker u-mt-- u-ml- large-and-up-ml">
          <div
            className="c-colorpicker__color"
            onClick={field.onClick}
            style={{ background: value }}
          />
          {picker}
        </div>
      );
    };
  }

  handleClick() {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  }

  handleClose() {
    this.setState({ displayColorPicker: false });
  }

  handleChange(color) {
    this.changeColor(color.hex);
  }

  render() {
    return (
      <Field
        name={this.props.name}
        component={this.fieldInput}
        onClick={this.handleClick.bind(this)}
      />
    );
  }
}
